<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <b-container fluid="">
      <b-row>
        <b-col>
          <b-card header-tag="header">
            <template #header>
              <card-title>
                <b-icon class="icono" icon="file-text"></b-icon>Tratamientos
                programados activos/inactivos
              </card-title>
            </template>

            <!-- opciones selecionar todo y generar Replica -->

            <!-- opciones selecionar todo y generar Replica -->

            <b-card-body class="scrollx">
              <b-row>
                <b-col>
                  <b-table
                    thead-tr-class="columnas"
                    class="parrafos"
                    hover
                    id="tratamientos"
                    :items="tratamientossesion"
                    :fields="fields"
                    :per-page="registrosPorPagina"
                    :current-page="paginaActual"
                    selectable
                    :select-mode="selectMode"
                    @row-selected="(items) => onRowSelected(items)"
                    :ref="1"
                  >
                    <template v-slot:cell(fechaAlta)="row">
                      <div>
                        {{ row.item.fechaAlta | formatoFechaHoraTexto }}
                      </div>
                    </template>
                    <template v-slot:cell(descripcionTratamiento)="row">
                      <div>
                        {{
                          row.item.descripcionTratamiento === null ||
                          row.item.descripcionTratamiento === ""
                            ? "Sin dato"
                            : row.item.descripcionTratamiento
                        }}
                      </div>
                    </template>
                    <template v-slot:cell(doctor)="row">
                      <div>
                        {{
                          row.item.doctor === null || row.item.doctor === ""
                            ? "Sin dato"
                            : row.item.doctor
                        }}
                      </div>
                    </template>
                    <template v-slot:cell(precioTotal)="row">
                      <div>{{ row.item.precioTotal | moneda }}</div>
                    </template>

                    <template v-slot:cell(numeroSesion)="row">
                      <div>
                        {{
                          row.item.numeroSesion === null ||
                          row.item.numeroSesion === ""
                            ? "Sin dato"
                            : row.item.numeroSesion +
                              "/" +
                              row.item.numeroMaxSesiones
                        }}
                      </div>
                    </template>
                    <template v-slot:cell(descuento)="row">
                      <div>
                        {{
                          row.item.descuento === null ||
                          row.item.descuento === ""
                            ? "Sin dato"
                            : row.item.descuento + "%"
                        }}
                      </div>
                    </template>
                    <template v-slot:cell(precioSesion)="row">
                      <div>
                        {{ row.item.precioSesion | moneda }}
                      </div>
                    </template>
                    <template v-slot:cell(saldoFavor)="row">
                      <div>
                        {{ row.item.saldoFavor | moneda }}
                      </div>
                    </template>
                    <template v-slot:cell(nombrePlan)="row">
                      <div>
                        {{
                          row.item.nombrePlan === null ||
                          row.item.nombrePlan === ""
                            ? "Sin dato"
                            : row.item.nombrePlan
                        }}
                      </div>
                    </template>
                    <template v-slot:cell(fechaModificacion)="row">
                      <div>
                        {{ row.item.fechaModificacion | formatoFechaHoraTexto }}
                      </div>
                    </template>

                    <template v-slot:cell(presupuestoHistorico)="row">
                      <span v-if="row.item.presupuestoHistorico == true">
                        <b-badge variant="success"
                          ><b-icon icon="check-square" font-scale="1.5"></b-icon
                        ></b-badge>
                      </span>
                      <span v-else>
                        <b-badge variant="warning"
                          ><b-icon icon="x-square" font-scale="1.5"></b-icon
                        ></b-badge>
                      </span>
                    </template>

                    <template v-slot:cell(Actualizar)="row">
                      <b-button-group>
                        <div v-if="row.item.puedeActualizarPrecio">
                          <b-button
                          
                          title="Activar tratamiento"
                          variant="outline-primary"
                          size="sm"
                          @click="verModalActualizarPrecio(row.item)"
                          ><em class="fa fa-refresh"></em
                        ></b-button>
                        </div>
                        <div v-else>
                          <p>El precio coincide</p>
                        </div>
                      
                      </b-button-group>
                    </template>

                    <template v-slot:cell(Acciones)="row">
                      <b-button-group>
                        <b-button
                          v-if="!row.item.registroActivo"
                          title="Activar tratamiento"
                          variant="outline-success"
                          size="sm"
                          @click="verModalActivarDesactivarTx(row.item)"
                          ><em class="fa fa-undo"></em
                        ></b-button>
                        <b-button
                          v-if="row.item.registroActivo"
                          title="Desactivar tratamiento"
                          variant="outline-danger"
                          size="sm"
                          @click="verModalActivarDesactivarTx(row.item)"
                        >
                          <b-icon icon="trash-fill"></b-icon>
                        </b-button>
                      </b-button-group>
                    </template>
                  </b-table>
                  <b-pagination
                    v-if="
                      tratamientossesion !== undefined &&
                      tratamientossesion.length > 15
                    "
                    align="center"
                    v-model="paginaActual"
                    :total-rows="tratamientossesion.length"
                    :per-page="registrosPorPagina"
                    aria-controls="tratamientos"
                  ></b-pagination>
                  <div align="center" v-if="loaderListaTratamientos">
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                  </div>
                  <div
                    v-if="
                      tratamientossesion.length === 0 &&
                      loaderListaTratamientos === false
                    "
                    align="center"
                  >
                    <b-alert show variant="warning">No hay datos</b-alert>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      v-model="modalActivarDesactivarTx"
      :title="tituloModal"
      scrollable
      size="lg"
    >
      <div class="m-4">
        <p style="font-weight: 600" v-if="!itemActivo">
          Debe seleccionar un motivo para activar el tratamiento
        </p>
        <p style="font-weight: 600" v-if="itemActivo">
          Debe seleccionar un motivo para desactivar el tratamiento
        </p>

        <b-form-group
          v-if="!itemActivo"
          label="Motivo de activación"
          label-align="left"
          class="mginInputTrt"
          id="fieldset-5"
        >
          <v-select
            :options="motivosActivacion"
            :reduce="(variable) => variable"
            label="descripcionMotivo"
            v-model="motivoSeleccionado"
          />
          <!--  <b-form-invalid-feedback :state="tratamiento.idRiesgo!= null">
                Selecionar riesgo
              </b-form-invalid-feedback> -->
        </b-form-group>
        <b-form-group
          v-if="itemActivo"
          label="Motivo de desactivación"
          label-align="left"
          class="mginInputTrt"
          id="fieldset-5"
        >
          <v-select
            :options="motivosCancelacion"
            :reduce="(variable) => variable"
            label="descripcionMotivo"
            v-model="motivoSeleccionado"
          />
          <!--  <b-form-invalid-feedback :state="tratamiento.idRiesgo!= null">
                Selecionar riesgo
              </b-form-invalid-feedback> -->
        </b-form-group>
        <!--  <v-select
                                      label="nombre"
                                      :options=" dataTreatmentsMixto "
                                      v-model="itemDos.idTratamiento"
                                      :reduce="(variable) => variable.idTratamiento"
                                      @input="sendTreatment"
                                  ></v-select> -->
        <br /><br />
      </div>
      <div slot="modal-footer">
        <b-button
          variant="outline-primary"
          :disabled="loading"
          @click="guardarTx()"
        >
          <span v-if="!loading">Guardar</span>
          <span v-if="loading">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button
          variant="outline-danger"
          :disabled="loading"
          @click="cerrarModal()"
          >Cancelar</b-button
        >
      </div>
    </b-modal>

    <b-modal
    v-model="modalActualizarPrecio"
    :title="tituloModal"
    scrollable
    size="lg"
  >
    <div class="m-4">
      <p style="font-weight: 600" v-if="!itemActivo">
        Por favor verifique la información
      </p>
      <b-table-simple small="small" style="margin-top: 1%">
        <b-tbody class="text-left">
          <b-tr>
            <b-th>Precio actual de tx</b-th>
            <b-td>${{ txSeleccionado != null ? txSeleccionado.precioTotal : ""}}</b-td>
          </b-tr>
          <b-tr>
            <b-th>Precio de catálogo</b-th>
            <b-td>${{ txSeleccionado != null ? txSeleccionado.costoCatalogoTx : "" }}</b-td>
          </b-tr>   

        </b-tbody>
      </b-table-simple>
      <br /><br />
    </div>
    <div slot="modal-footer">
      <b-button
        variant="outline-primary"
        :disabled="loading"
        @click="actualizarPrecios()"
      >
        <span v-if="!loading">Guardar</span>
        <span v-if="loading">
          <b-spinner small></b-spinner>
          Cargando...
        </span>
      </b-button>
      <b-button
        variant="outline-danger"
        :disabled="loading"
        @click="modalActualizarPrecio = false"
        >Cancelar</b-button
      >
    </div>
  </b-modal>
  </div>
</template>

<script>
import miniToastr from "mini-toastr";
import _ from "lodash";

export default {
  name: "activacionTratamientos",
  components: {},
  props: {
    idPaciente: null,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    banderaBtn: false,
    selected: [],
    selectMode: "multi",
    tratamientossesion: [],
    loaderListaTratamientos: false,
    currentPage: 1,
    registrosPorPagina: 15,
    paginaActual: 1,
    fields: [
    { key: "saldoAFavor", label: "Saldo a favor", sortable: true },
    { key: "nombreTratamiento", label: "Tratamiento", sortable: true },
      { key: "descripcionTratamiento", label: "Comentarios", sortable: true },
      { key: "doctor", label: "Doctor", sortable: true },
      { key: "numeroDiente", label: "OD", sortable: true },
      {
        key: "origen",
        label: "Origen",
        sortable: true,
      },
      { key: "nombrePlan", label: "Plan-convenio", sortable: true },
      { key: "fechaAlta", label: " Fecha presupuesto ", sortable: true },
      { key: "empleadoUsrModificacion", label: "Empleado que modificó ", sortable: true },
      { key: "fechaModificacion", label: " Fecha modificación ", sortable: true },
      "Actualizar",
      "Acciones",
    ],
    modalActivarDesactivarTx: false,
    tituloModal: "",
    motivosTx: [],
    motivosCancelacion: [],
    motivosActivacion: [],
    motivoSeleccionado: {},
    itemActivo: null,
    txSeleccionado: null,
    loading: false,
    modalActualizarPrecio:false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerMotivosTx();
  },

  mounted() {
    this.obtenerListaTratamientos();
  },
  methods: {
    actualizarPrecios(){
      this.$swal
          .fire({
            title: "¿Estás seguro de actualizar el precio por el precio de catálogo? ",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
          })
          .then(() => {
            this.$http
                .post(
                  this.$api +
                    "tratamiento_sesion/actualizarPreciosTratamiento?idTratamientoProgramado=" +
                    this.txSeleccionado.idTratamientoProgramado
                )

                .then(() => {
                  this.modalActualizarPrecio = false
                  this.obtenerListaTratamientos();
                }).catch((error) => {
                  console.error(error);
                })


          })
    },
    guardarTx() {
      this.loading = true;
      const parametros ={
        idTratamiento: this.txSeleccionado.idTratamientoProgramado,
        idTipoMotivo: this.motivoSeleccionado.idTipoMotivo,
        idMotivo: this.motivoSeleccionado.idMotivo,
      }
      this.$http.put(
          this.$api +
            "tratamiento_sesion/guardarMotivostx", parametros  )

        .then((response) => {
          if (response.data.data) {
            const indice = this.tratamientossesion.findIndex(
              (elemento) => {
                if (
                  elemento.idTratamientoProgramado ===
                  this.txSeleccionado.idTratamientoProgramado
                ) {

                  return true;
                }
              }
            );
            this.tratamientossesion[indice].registroActivo = !this.itemActivo;
            this.$swal({
              icon: "success",
              title: "El nuevo estatus del tratamiento se guardó exitosamente",
              showConfirmButton: true,
              timer: 2500,
            });
            this.modalActivarDesactivarTx = false;
            this.motivoSeleccionado = {};
            this.obtenerListaTratamientos();
          }
        })
        .catch(function (error) {
          console.error(error);
          this.loaderListaTratamientos = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cerrarModal() {
      this.modalActivarDesactivarTx = false;
      this.motivoSeleccionado = {};
    },
    obtenerMotivosTx() {
      this.motivosTx = [];
      this.loaderListaTratamientos = true;
      this.$http
        .get(
          this.$api + "tratamiento_sesion/obtenerMotivosCancelacionActivacionTx"
        )
        .then((response) => {
          if (response.data.data) {
            let resultado = response.data.data;
            resultado.forEach((it) => {
              if (it.idTipoMotivo == 1) {
                this.motivosActivacion.push(it);
              } else if (it.idTipoMotivo == 2) {
                this.motivosCancelacion.push(it);
              }
            });
          }
          this.loaderListaTratamientos = false;
        })
        .catch(function (error) {
          console.error(error);
          this.loaderListaTratamientos = false;
        });
    },
    verModalActivarDesactivarTx(item) {
      this.modalActivarDesactivarTx = true;
      this.tituloModal = item.registroActivo
        ? "Desactivar tratamiento"
        : "Activar tratamiento";
      this.itemActivo = item.registroActivo;
      this.txSeleccionado = item;
    },
    verModalActualizarPrecio(item) {
      this.modalActualizarPrecio = true;
      this.tituloModal = "¿Desea actualizar el costo del tratamiento por el precio del catálogo?"
      this.txSeleccionado = item;
    },

    generarPtiReplica(registros) {
      var banderaProgramados = false;
      var banderaHistoricos = false;

      registros.forEach((element) => {
        if (element.idEstatusTratamiento == 15) {
          banderaProgramados = true;
        } else if (!element.presupuestoHistorico) {
          banderaHistoricos = true;
        }
      });

      if (banderaProgramados) {
        miniToastr.warn(
          "Los tratamientos seleccionados ya fueron pagados, se reinició la lista"
        );
        this.$refs[1].clearSelected();
      } else if (banderaHistoricos) {
        miniToastr.warn(
          "Los tratamientos no pertenecen a un presupuesto histórico"
        );
        this.$refs[1].clearSelected();
      } else {
        this.$swal
          .fire({
            title: "¿Estás seguro de generar el PTI con estos tratamientos? ",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
          })
          .then((result) => {
            //LIMPIAR IDs de tratamientos duplicados
            this.selected = _.uniqBy(this.selected, function (e) {
              return e.idTratamiento;
            });

            if (result.isConfirmed) {
              this.banderaBtn = true;
              this.$http
                .put(
                  this.$api +
                    "diagnostico/programados/pti?idUsuario=" +
                    this.$localStorageService.getIdUsuario() +
                    "&idClinica=" +
                    this.$localStorageService.getIdClinica() +
                    "&idEmpleado=" +
                    this.$localStorageService.getIdEmpleado() +
                    "&idPaciente=" +
                    this.idPaciente,
                  {
                    listaTrts: this.selected,
                  }
                )
                .then(() => {
                  this.$swal({
                    icon: "success",
                    title: "Se ingresó correctamente",
                    showConfirmButton: false,
                    timer: 2500,
                    onClose: () => {},
                  });
                  miniToastr.success("Se guardo correctamente el registro");
                })
                .catch((error) => {
                  this.banderaBtn = false;
                  this.$swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                  });
                })
                .finally(() => {
                  this.selected = [];
                  this.$refs[1].clearSelected();
                  this.obtenerListaTratamientos();
                });
            }
          });
      }

    },
    onRowSelected(items) {
      this.selected = items;
    },
    /**
     * Funcion para obtener los tratamientos programados
     */
    obtenerListaTratamientos() {
      this.tratamientossesion = [];
      this.loaderListaTratamientos = true;
      const parametros = {
        idPaciente: this.idPaciente,
        isBandejaActivacion: true
      }
      this.$http
        .post(
          this.$api +
            "tratamiento_sesion/listadotratamientos", parametros
        )
        .then((response) => {
          if (response.data.data) {
            let resultado = response.data.data;
            resultado.forEach((it) => {
              this.paginaActual = 1;
              this.tratamientossesion.push(it);
            });
          }
          this.loaderListaTratamientos = false;
        })
        .catch(function (error) {
          console.error(error);
          this.loaderListaTratamientos = false;
        });
    },
  },
};
</script>

<style scoped>
.flxButton {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.mginLeft {
  margin-left: 15px;
}
</style>
